import {
    CONTACT_STATUS_OPTIONS,
} from "../../../constants/admin/contact/contactConstants";

import {
    getStatusBadgeClass,
    getStatusLabel,
} from "../../../utils/admin/contactUtils";

export default function ContactTable({
    contacts,
    isAdmin,
    onStatusChange,
}) {
    return (
        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
            <table className="min-w-full text-sm">
                <tbody>
                    {contacts.map((contact) => (
                        <tr key={contact.id}>
                            <td>{contact.fullName}</td>

                            <td>{contact.email}</td>

                            <td>{contact.phone || "—"}</td>

                            <td>{contact.message}</td>

                            <td>
                                <span
                                    className={`px-2 py-1 rounded text-white text-xs ${getStatusBadgeClass(
                                        contact.status
                                    )}`}
                                >
                                    {getStatusLabel(
                                        contact.status
                                    )}
                                </span>
                            </td>

                            <td>
                                {isAdmin && (
                                    <select
                                        value={contact.status}
                                        onChange={(e) =>
                                            onStatusChange(
                                                contact.id,
                                                e.target.value
                                            )
                                        }
                                    >
                                        {CONTACT_STATUS_OPTIONS.map(
                                            (option) => (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            )
                                        )}
                                    </select>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}